import * as React from "react"
export const Svg_057 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M58 29.5c0-5.916-1.694-11.569-4.912-16.433 1.464-2.26 1.22-5.337-.734-7.324a5.664 5.664 0 0 0-7.2-.746A28.407 28.407 0 0 0 29 0a28.408 28.408 0 0 0-16.154 4.997 5.664 5.664 0 0 0-7.2.746c-1.953 1.987-2.198 5.064-.734 7.324C1.694 17.932 0 23.584 0 29.5s1.694 11.569 4.912 16.433c-1.464 2.26-1.22 5.337.734 7.324a5.66 5.66 0 0 0 7.2.746A28.407 28.407 0 0 0 29 59a28.407 28.407 0 0 0 16.154-4.997 5.66 5.66 0 0 0 7.2-.747c1.953-1.986 2.198-5.063.734-7.323C56.306 41.069 58 35.416 58 29.5ZM15.008 51.314c.828-2.101.407-4.597-1.263-6.296a5.665 5.665 0 0 0-6.189-1.284c-2.725-4.232-4.158-9.12-4.158-14.234 0-5.113 1.433-10.003 4.158-14.234a5.662 5.662 0 0 0 6.189-1.284c1.67-1.7 2.09-4.195 1.263-6.296A25.07 25.07 0 0 1 29 3.457a25.07 25.07 0 0 1 13.992 4.23c-.828 2.1-.407 4.596 1.263 6.295a5.66 5.66 0 0 0 6.189 1.284c2.725 4.231 4.158 9.12 4.158 14.234 0 5.113-1.433 10.002-4.158 14.234a5.665 5.665 0 0 0-6.189 1.284c-1.67 1.7-2.09 4.195-1.263 6.296A25.07 25.07 0 0 1 29 55.543a25.07 25.07 0 0 1-13.992-4.23Z"
      />
      <path
        fill="url(#c)"
        d="M29 11.3c-9.865 0-17.891 8.165-17.891 18.2S19.135 47.7 29 47.7c9.865 0 17.891-8.165 17.891-18.2S38.865 11.3 29 11.3Zm-.649 16.471h1.297c2.854 0 5.175 2.362 5.175 5.264 0 2.537-1.773 4.66-4.124 5.155v2.309h-3.398V38.26c-2.323-.302-4.124-2.325-4.124-4.769h3.398c0 .745.596 1.35 1.328 1.35h1.746c.98 0 1.776-.81 1.776-1.806s-.797-1.806-1.776-1.806h-1.297c-2.854 0-5.175-2.362-5.175-5.264 0-2.537 1.773-4.66 4.124-5.155v-2.309h3.398v2.239c2.323.302 4.124 2.325 4.124 4.769h-3.398a1.34 1.34 0 0 0-1.328-1.351h-1.746c-.98 0-1.776.81-1.776 1.807 0 .996.797 1.806 1.776 1.806Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={13.412}
        x2={41.649}
        y1={8.85}
        y2={53.775}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={19.383}
        x2={36.804}
        y1={16.76}
        y2={44.476}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h58v59H0z" />
      </clipPath>
    </defs>
  </svg>
)